import type { Onset } from "@/types/emr/symptom/symptom";
import { format } from "date-fns";

export function conditionOnsetForRequest(onset?: Onset): Onset | undefined {
  if (!onset) return undefined;
  const { onset_datetime, ...otherOnset } = onset;
  // Existing free-text records have an empty onset object. Do not invent an
  // empty datetime when loading them into an editable questionnaire.
  return {
    ...otherOnset,
    ...(onset_datetime
      ? { onset_datetime: format(new Date(onset_datetime), "yyyy-MM-dd") }
      : {}),
  };
}
